<template>
  <div class="fixed inset-0 z-50" role="dialog" aria-modal="true">
    <div class="absolute inset-0 bg-gray-800 bg-opacity-60" @click="close" />

    <div class="absolute inset-0 overflow-y-auto">
      <div class="min-h-full flex items-center justify-center p-4 sm:p-6">
        <div class="w-full max-w-3xl rounded-xl bg-white shadow-xl ring-1 ring-black ring-opacity-5">
          <div class="p-6 sm:p-8">
            <div class="flex items-start justify-between gap-4">
              <div>
                <h2 class="text-xl sm:text-2xl font-semibold text-gray-900">Embed Kairo blocks (Notion)</h2>
                <p class="mt-1 text-sm text-gray-600">Quick steps to get your Embed URL and add it to Notion.</p>
              </div>
              <button
                type="button"
                class="inline-flex items-center justify-center rounded-md p-2 text-gray-500 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-500"
                @click="close"
              >
                <span class="sr-only">Close</span>
                <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
                </svg>
              </button>
            </div>

            <div class="mt-6 rounded-lg border border-amber-200 bg-amber-50 p-4">
              <p class="text-sm text-amber-900">
                <strong>Important:</strong> Make sure to <strong>Save the Board</strong> first. Embeds work best once your board and blocks are saved.
              </p>
            </div>

            <div class="mt-6 space-y-6 text-sm text-gray-700 leading-relaxed">
              <p>
                In Kairo, you can embed blocks anywhere. The most common use is embedding Kairo blocks in Notion.
              </p>

              <div>
                <h3 class="text-base font-semibold text-gray-900">How to get the Embed URL</h3>
                <div class="mt-2 border-t border-gray-200" />

                <div class="mt-4 space-y-3">
                  <div class="flex items-start gap-3">
                    <img
                      alt=""
                      class="h-6 w-6 flex-none"
                      src="https://files-storage.inlinemanual.com/da97f859-2b86-4efc-ad24-1e7f5196c970.png"
                    />
                    <div>
                      Edit the block by clicking on the <strong>Edit</strong> link.
                    </div>
                  </div>

                  <p>At the top, navigate to the <strong>Embed</strong> tab.</p>
                  <p>
                    Enable the Embed functionality — it will expose a link that you can copy by clicking on the clipboard.
                  </p>

                  <p>
                    The <strong>View</strong> mode embeds the block in read-only mode (people can’t start/stop it).
                  </p>
                  <p>
                    The <strong>Update</strong> mode allows anyone seeing the embedded block to start or stop it.
                  </p>
                </div>

                <div class="mt-4 border-t border-gray-200" />
              </div>

              <div>
                <div class="flex items-start gap-3">
                  <img
                    alt=""
                    class="h-10 w-10 flex-none"
                    src="https://files-storage.inlinemanual.com/4cd03872-50b8-4be5-84f0-d533811dea03.png"
                  />
                  <div>
                    <h3 class="text-base font-semibold text-gray-900">How to embed Kairo blocks in Notion pages</h3>
                  </div>
                </div>

                <div class="mt-3 space-y-3">
                  <p>Once you copy the Embed URL, navigate to your Notion application.</p>
                  <p>Add a new block by using the <strong>/embed</strong> command and paste the link there.</p>
                  <p>
                    You can then freely move the block around, and you can also adjust its size by dragging the sides.
                  </p>

                  <img
                    alt="Embedding Kairo blocks in Notion"
                    class="mt-3 w-full rounded-lg border border-gray-200"
                    src="https://files-storage.inlinemanual.com/a211fbf8-eebc-483e-83de-008b8be7e588.gif"
                  />
                </div>
              </div>
            </div>

            <div class="mt-8 flex items-center justify-end">
              <button
                type="button"
                class="inline-flex items-center justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-white bg-green-600 hover:bg-green-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                @click="close"
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmbedHelpModal',
  emits: ['close'],
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
